export default [
  {
    path: "/settings/trackings",
    name: "Tracking",
    component: () => import("@/views/3pl/Settings/Tracking/index"),
  },
  {
    path: "/settings/tracking/update-tracking",
    name: "UpdateTracking",
    component: () => import("@/views/3pl/Settings/Tracking/UpdateTracking"),
  },
  {
    path: "/settings/tracking/shippment-timeline/:id",
    name: "TrackingShippmentTimeline",
    component: () => import("@/views/3pl/Settings/Tracking/ShippmentTimeline"),
  },
  // {
  //   path: "/settings/Tracking/edit",
  //   name: "EditVehicle",
  //   component: () => import("@/views/3pl/Settings/Tracking/EditVehicle"),
  // },
];
